export const getPriceWithDiscountList = (product, unitsp, chartProducts, iarrProm, PromotionTotal) => {
  let units = unitsp || 1; // Precio base del producto
  let productPrice = product?.salePrice || 0; // Precio base del producto
  //console.log('PromotionTotal',PromotionTotal);
  //console.log('product-product',product);
  //console.log('productPrice1',productPrice);

  let totalDiscount = 0;
  let finalPrice = productPrice;
  let arrPromotionCode = [];
  let arrGiftSKU = [];
  let arrToghetherListSKU = [];
  let AplicaPromo = false;
  if (product.promotions != null) {
    for (const promo of product.promotions) {
      //console.log('product-promo',promo);
      const PromoType = promo?.promoType || ''; // Tipo de promocion
      const { DiscountType = '', DiscountValue = 0, GiftQuantity= 1, GiftSKU = '', DiscountDetailTiers = [], List1 = null, List2 = null} = promo.DiscountDetail || {};
      // Validar MinValue, MaxValue y TypeValue
      //console.log('DiscountDetail',promo.DiscountDetail);
      let MinValue = promo.Conditions?.ItemValueRange?.MinValue || 0; // Predeterminado a 0 si es nulo o no definido
      let MaxValue = promo.Conditions?.ItemValueRange?.MaxValue || Number.MAX_SAFE_INTEGER; // Máximo permitido
      const TypeValue = promo.Conditions?.ItemValueRange?.TypeValue || "QUANTITY"; // Predeterminado a QUANTITY

      if (PromotionTotal != null)//en el caso q aplique surtidos, en caso se nulos mantiene el valor de la promo
      {
        //console.log('surtido');
        let promoexists = PromotionTotal?.find((promoe) => promoe.code === promo.code);
        console.log('promoexists', promoexists);
        if (promoexists != null && product.ProductType == 'BASE')
        {
          if (promoexists.TypeValue == "QUANTITY" && promoexists.promoType == "REGULAR" && promoexists.amountTotal >= promoexists.MinValue)
          {
            let iMax = promoexists.MaxUsed <= (promoexists.MaxValue || MaxValue) ? promoexists.MaxUsed : promoexists.MaxValue - promoexists.MaxUsed + units;
            MinValue = iMax <= 0 ? Number.MAX_SAFE_INTEGER : 1;
            MaxValue = iMax <= 0 ? Number.MAX_SAFE_INTEGER : iMax;
          }
          if (promoexists.TypeValue == "AMOUNT" && promoexists.promoType == "REGULAR" && promoexists.Total >= promoexists.MinValue)
            {
              let iMax = promoexists.TotalUsed <= (promoexists.MaxValue || MaxValue) ? promoexists.TotalUsed : promoexists.MaxValue - promoexists.TotalUsed + (units * product.salePrice);
              MinValue = iMax <= 0 ? Number.MAX_SAFE_INTEGER : 1;
              MaxValue = iMax <= 0 ? Number.MAX_SAFE_INTEGER : iMax;
            }
        }
      }
 
      var aaa = {iarrPromotionCodeQuantity : iarrProm, productcode: product.code,
        StockPerCustomer: promo.StockPerCustomer, StockPerStore: promo.StockPerStore, PromoCode: promo.code
        , MinValue: MinValue, MaxValue: MaxValue, TypeValue: TypeValue, DiscountValue: DiscountValue,
        PromoType: PromoType, iarrProm:iarrProm, DiscountType: DiscountType
        , promo: promo, units: units, productPrice : productPrice
      };
      console.log('aaaaa',aaa);
      if ((promo.StockPerCustomer != 0 &&  iarrProm < promo.StockPerCustomer) && 
          (promo.StockPerStore != 0 && iarrProm < promo.StockPerStore)
        ) 
      {
          console.log('entra PROMO');
          AplicaPromo = true;
          if (PromoType === 'REGULAR') {
            // Lógica para "QUANTITY"
              if (TypeValue === "QUANTITY") {
                if (units >= MinValue) {
                  const applicableQuantity = Math.min(units, MaxValue); // Cantidad máxima aplicable
                  console.log('applicableQuantity',applicableQuantity);
                  let currentDiscount = 0;

                  if (DiscountType === 'NOMINAL') {
                    currentDiscount = applicableQuantity ; // Descuento nominal por unidad
                    //console.log('currentDiscount',currentDiscount);
                    //console.log('DiscountValue',DiscountValue);
                    
                    let NewproductPrice = ((productPrice * units) - DiscountValue) / units;//Descuento el monto fijo
                    currentDiscount = productPrice - NewproductPrice;
                    totalDiscount += currentDiscount;
                    finalPrice = productPrice - totalDiscount;//ACUMULA el precio de descuento
                    //finalPrice = NewproductPrice;
                    if (product.ProductType == 'BASE')
                      arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                    //console.log('productPrice2',productPrice);
                  } else if (DiscountType === 'PERCENTAGE') {
                    //console.log('DiscountValue',DiscountValue);
                    const unitPrice = productPrice / units;
                    //console.log('unitPrice',unitPrice);
                    currentDiscount = unitPrice * DiscountValue / 100 * applicableQuantity; // Descuento porcentual
                    console.log('currentDiscount',currentDiscount);
                    totalDiscount += currentDiscount;
                    console.log('totalDiscountPrice',totalDiscount);
                    finalPrice = productPrice - totalDiscount;//ACUMULA el precio de descuento
                    console.log('finalPrice',finalPrice * units);
                    if (product.ProductType == 'BASE')
                      arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                  }
                }
                else
                {
                  console.log('NO APLICA CANT MIN');
                }
              }
              let currentDiscount = 0;
              // Lógica para "AMOUNT"
              if (TypeValue === "AMOUNT") {
                const totalAmount = units * productPrice; // Total del monto de la compra
                //console.log('totalAmount',totalAmount);
                if (totalAmount >= MinValue) {
                  const applicableAmount = Math.min(totalAmount, MaxValue); // Monto máximo aplicable
                  //console.log('applicableAmount',applicableAmount);
                  //console.log('productPrice',productPrice);
                  const applicableUnits = applicableAmount / productPrice; // Unidades correspondientes al monto aplicable

                  

                  if (DiscountType === 'NOMINAL') {
                    currentDiscount = DiscountValue; // Descuento nominal
                    if (product.ProductType == 'BASE')
                      arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                  } else if (DiscountType === 'PERCENTAGE') {
                    //console.log('DiscountValue',DiscountValue);
                    currentDiscount = applicableAmount * DiscountValue / 100; // Descuento porcentual
                    if (product.ProductType == 'BASE')
                      arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                  }
                  //console.log('currentDiscount-paercial',currentDiscount);
                  totalDiscount += currentDiscount;
                  //console.log('totalDiscount',totalDiscount);
                }
                productPrice = ((productPrice * units) - currentDiscount) / units;//CURRENDISCOUNT por promociones concurrentes
                //console.log('productPrice-parcial',productPrice);
                //console.log('totalDiscount-parcial',totalDiscount);
                finalPrice = productPrice;
              }
          }
          if (PromoType === 'BUY_ONE_GET_ONE') {
            // Lógica para "QUANTITY"
            //console.log('GIFT-',promo);
            //console.log('TypeValue',TypeValue);
              if (TypeValue === "QUANTITY") {
                //console.log('units',units);
                //console.log('MinValue',MinValue);

                // if (units >= MinValue) {
                  //console.log('GIFT','QUANTITY2');
                  const applicableQuantity = Math.min(units, MaxValue); // Cantidad máxima aplicable
                  
                  let currentDiscount = 0;

                  if (DiscountType === 'GIFT') {
                    arrGiftSKU.push({ GiftQuantity: promo.DiscountDetail.GiftQuantity, GiftSKU: promo.DiscountDetail.GiftSKU,  DiscountValue: promo.DiscountDetail.DiscountValue,  giftAdd: (units >= MinValue)});
                    totalDiscount += currentDiscount;
                    finalPrice = productPrice - totalDiscount;
                    if (product.ProductType == 'BASE')
                    arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                  }
                // }
              }

              // Lógica para "AMOUNT"
              if (TypeValue === "AMOUNT") {
                //console.log('AMOUNT',TypeValue);
                const totalAmount = units * productPrice; // Total del monto de la compra
              // console.log('totalAmount',totalAmount);
                //console.log('MinValue',MinValue);
                // if (totalAmount >= MinValue) {
                  const applicableAmount = Math.min(totalAmount, MaxValue); // Monto máximo aplicable
                  //console.log('applicableAmount',applicableAmount);
                  //console.log('DiscountType',DiscountType);
                  const applicableUnits = applicableAmount / productPrice; // Unidades correspondientes al monto aplicable

                  let currentDiscount = 0;

                  if (DiscountType === 'GIFT') {
                    arrGiftSKU.push({ GiftQuantity: promo.DiscountDetail.GiftQuantity, GiftSKU: promo.DiscountDetail.GiftSKU,  DiscountValue: promo.DiscountDetail.DiscountValue, giftAdd: (totalAmount >= MinValue) });
                    //console.log('DiscountValue',DiscountValue);
                  //console.log('currentDiscount',currentDiscount);
                  totalDiscount += currentDiscount;
                  if (product.ProductType == 'BASE')
                    arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                }
                let NewproductPrice = ((productPrice * units) - totalDiscount) / units;
                finalPrice = NewproductPrice;
              }
          }

          if (PromoType === 'PROGRESSIVE_DISCOUNT') {
            // Lógica para "QUANTITY"
            //console.log('PROGRESSIVE_DISCOUNT-',promo);
            //console.log('TypeValue',TypeValue);

            // Obtener el máximo valor de Quantity <= unitsP
              const maxDiscountDetail = DiscountDetailTiers.reduce((max, tier) => {
                return tier.Quantity <= units && tier.Quantity > max.Quantity ? tier : max;
              }, { Quantity: 0, Discount: 0 });
              //console.log('maxDiscountDetail-',maxDiscountDetail);
              if (TypeValue === "QUANTITY") {
                let currentDiscount = 0;
                let DiscountValue = maxDiscountDetail.Discount;//el descuento q tendra
                let MaxValue = maxDiscountDetail.Quantity;//y el maximo de elementos q es alcanzable por la promocion

                const applicableQuantity = Math.min(units, MaxValue); // Cantidad máxima aplicable
                //console.log('maxDiscountDetail-DISCOUNT',maxDiscountDetail.Discount);
                
                const unitPrice = productPrice / units;
                //console.log('productPrice',productPrice);
                currentDiscount = unitPrice * DiscountValue / 100 * applicableQuantity; // Descuento porcentual
                //console.log('currentDiscount',currentDiscount);
                totalDiscount += currentDiscount;
                finalPrice = productPrice - totalDiscount;
                if (product.ProductType == 'BASE')
                  arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                
                  
                // }
              }
          }

          if (PromoType === 'PROGRESSIVE_GIFT') {
          //console.log('PROGRESSIVE_GIFT',promo);
            //console.log('TypeValue',TypeValue);

            // Obtener el máximo valor de Quantity <= unitsP
              const maxDiscountDetail = DiscountDetailTiers.reduce((max, tier) => {
                return tier.Quantity <= units && tier.Quantity > max.Quantity ? tier : max;
              }, { Quantity: 0, Discount: 0 });
              //console.log('maxDiscountDetail-s',maxDiscountDetail);
              
              
              if (TypeValue === "QUANTITY") {
                //console.log('units',units);
                let currentDiscount = 0;
                let DiscountValue = maxDiscountDetail.Discount;//aqui disconunt es la cangtidad a regalae
                let DiscountValue2 = promo.DiscountDetail?.DiscountValue ||  100;//el descuento q tendra por defecto 100 si no se le indics
                //console.log('qqqqqqqqq', promo.DiscountDetail);
                let MaxValue = maxDiscountDetail.Quantity;//y el maximo de elementos q es alcanzable por la promocion

                  const applicableQuantity = Math.min(units, MaxValue); // Cantidad máxima aplicable
                  //console.log('maxDiscountDetail-DISCOUNT',DiscountValue);

                  if (DiscountType === 'GIFT') {
                    arrGiftSKU.push({ GiftQuantity: DiscountValue, GiftSKU: promo.DiscountDetail.GiftSKU,  DiscountValue:DiscountValue2, giftAdd: (units >= DiscountValue && DiscountValue != 0)});

                    totalDiscount += currentDiscount;
                    finalPrice = productPrice - totalDiscount;
                    if (product.ProductType == 'BASE')
                      arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:1, product:product });
                  }
                // }
              }
          }
          if (PromoType === 'BUY_TOGETHER' && List1 && List2) {
            // Lógica para "QUANTITY"
            console.log('BUY_TOGETHER-',promo);
            //console.log('TypeValue',TypeValue);
            var carritoOld = chartProducts == undefined ? JSON.parse(localStorage.getItem('chartProducts') || '[]') : chartProducts;         
            console.log('carritoOld',carritoOld);

            // const carrito = actualizarCarrito(structuredClone(carritoOld), List1, List2);
            // const ListP1 = actualizarSKUs(List1, units);
            // const ListP2 = actualizarSKUs(List2, units);
            // console.log('carritoAct',structuredClone(carrito));
            // console.log('List1',structuredClone(ListP1));
            // console.log('List2',structuredClone(ListP2));
            
            const carrito = carritoOld; 

            // Verificar si el producto actual está en List1 o List2
            const isInList1 = List1.SKUs.includes(product.code);
            const isInList2 = List2.SKUs.includes(product.code);
            // Si está en List1, buscar si hay productos de List2 en el carrito
            const hasList2InCart = carrito.some((item) => List2.SKUs.includes(item.product?.code) 
              && (item.product.code == product.code ? units : item.amount) >= List2.MinQuantity);

            const hasList1InCart = carrito.some((item) => List1.SKUs.includes(item.product?.code) 
              && (item.product.code == product.code ? units : item.amount) >= List1.MinQuantity);
    
            const eligibleList1 = List1.SKUs.filter(sku => {
              const item = carrito.find(item => item.product?.code === sku);
              const amount = item ? (item.product.code == product.code ? units : item.amount) : 0;
              return amount >= List1.MinQuantity;
            });

            const sumAmountList1 = eligibleList1.reduce((sum, sku) => {
              const item = carrito.find(item => item.product?.code === sku);
              return sum + (item ? (item.product.code == product.code ? units : item.amount) : 0);
            }, 0);
            const groupgif1 = Math.floor(sumAmountList1 / List1.MinQuantity);
            console.log('groupgif1',groupgif1);
            console.log('sumAmountList1',sumAmountList1);


            const eligibleList2 = List2.SKUs.filter(sku => {
              const item = carrito.find(item => item.product?.code === sku);
              return item && (item.product.code == product.code ? units : item.amount) >= List2.MinQuantity;
            });

            const sumAmountList2 = eligibleList2.reduce((sum, sku) => {
              const item = carrito.find(item => item.product?.code === sku);
              return sum + (item ? (item.product.code == product.code ? units : item.amount) : 0);
            }, 0);
            const groupgif2 = Math.floor(sumAmountList2 / List2.MinQuantity);
            console.log('groupgif2',groupgif2);
            console.log('sumAmountList2',sumAmountList2);

            // Determinar el número de pares válidos
            const pairs = Math.min(eligibleList1.length, eligibleList2.length);
            const pairsGifs = Math.min(groupgif1, groupgif2);
            console.log('pairsGifs',pairsGifs);
            console.log('pairs',pairs);

            // Verificar si el producto actual está en un par válido
            let isInValidPair = false;
            for (let i = 0; i < pairs; i++) {
              if ((isInList1 && eligibleList1[i] === product.code) || (isInList2 && eligibleList2[i] === product.code)) {
                isInValidPair = true;
                break;
              }
            }

            if (DiscountType === 'GIFT') {
                arrGiftSKU.push({ 
                  GiftQuantity: promo.DiscountDetail.GiftQuantity * (pairsGifs || 0), 
                  GiftSKU: promo.DiscountDetail.GiftSKU,  
                  DiscountValue: promo.DiscountDetail.DiscountValue,  
                  giftAdd: (hasList1InCart && hasList2InCart)
                });
            }

            if (isInValidPair) {
              // Guardar la lista opuesta a donde se encuentra el producto
              arrToghetherListSKU = (isInList1 ? List2.SKUs : List1.SKUs);
            

              if (TypeValue === "QUANTITY") {
                // Aplicar la lógica de promoción
                // Producto actual en List1 y hay productos de List2 en el carrito
                // Producto actual en List2 y hay productos de List1 en el carrito
                if ((isInList1 && hasList2InCart) || (isInList2 && hasList1InCart)) {
                  //console.log('Promoción válida para este producto');

                  // Obtener los detalles del descuento según la lista correspondiente
                    let DiscountValue = isInList1 ? List1.Discount : List2.Discount; // Descuento específico para la lista
                    const minQuantity = isInList1 ? List1.MinQuantity : List2.MinQuantity; // Cantidad mínima requerida para la lista
                    //devuelve la lista opuesta a donde se encuentra el producto
                    arrToghetherListSKU = (isInList1 ? List2.SKUs : List1.SKUs);
                    

                    if (units >= minQuantity) {
                      const groups = Math.floor(units / minQuantity);
                      const discountedUnits = groups * minQuantity;
                      // Calcular el descuento
                      let currentDiscount = 0;
                      let MaxValue = 9999;//y el maximo de elementos q es alcanzable por la promocion

                      const applicableQuantity = Math.min(discountedUnits, MaxValue); // Cantidad máxima aplicable
                      
                      const unitPrice = productPrice / units;
                      //console.log('productPrice',productPrice);
                      currentDiscount = unitPrice * DiscountValue / 100 * applicableQuantity; // Descuento porcentual
                      //console.log('currentDiscount',currentDiscount);
                      totalDiscount += currentDiscount;
                      finalPrice = productPrice - totalDiscount;
                      if (product.ProductType == 'BASE')
                        arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:0.5, product:product });//en el caso de listas por cada uno q se aplique la promocion se suma 0.5 para q en el par sea 1
                        //arrPromotionCode.push({promocode: promo.code, promoquantity:product.ProductType == 'PROMO' ?  unitsp: promo.DiscountDetail.GiftQuantity * (pairs || 1)});
                    }
                }
                  
                // }
              }
            }
          }
          //console.log('totalDiscount',totalDiscount);
      }
      else
      {
        AplicaPromo = false;
        //añade la promocion pero con cantidad 0
        if (product.ProductType == 'BASE')
          arrPromotionCode.push({code:product.code + '-' + promo.code, promocode: promo.code, promoquantity:0, product:product });//en el caso de listas por cada uno q se aplique la promocion se suma 0.5 para q en el par sea 1
      }
    }//
    //productPrice = finalPrice;
  }
  console.log('----------------------------');
  var ret = {arrpromotioncode : arrPromotionCode,productcode: product.code, PriceWithDiscount:  Number(finalPrice > 0 ? finalPrice : 0) || 0, Gifts:arrGiftSKU || [], ToghetherListSKU:arrToghetherListSKU || [], quantity: units, AplicaPromo: AplicaPromo };
   console.log('-PriceWithDiscount',ret);
  console.log('----------------------------');
  return ret;
};

function actualizarSKUs(List1, cantidad) {
    const nuevosSKUs = []; // Array para almacenar los nuevos SKUs
    const veces = Math.ceil(cantidad / List1.MinQuantity); // Número de veces que cabe el MinQuantity en la cantidad

    List1.SKUs.forEach(sku => {
        for (let i = 1; i <= veces; i++) {
            const nuevoSKU = `${sku}_${String(i).padStart(3, '0')}`; // Concatenar el sufijo
            nuevosSKUs.push(nuevoSKU); // Añadir al array de nuevos SKUs
        }
    });

    return {
        ...List1, // Mantener las propiedades originales
        SKUs: nuevosSKUs // Actualizar la lista de SKUs
    };
}

function actualizarCarrito(carrito, List1, List2) {
  const nuevoCarrito = [];
  const contadorPorSKU = {}; // Objeto para mantener el contador por SKU
  carrito.forEach(item => {
      const producto = item.product;
      const cantidad = item.amount;
      const sku = producto.code;
      //console.log('SKU:', sku);
      let minQuantity = 1; // Por defecto, el mínimo es 1

      // Verificar si el SKU está en List1 o List2 de la promoción
      if (List1.SKUs.includes(sku)) {
          minQuantity = List1.MinQuantity;
      } else if (List2.SKUs.includes(sku)) {
          minQuantity = List2.MinQuantity;
      }

      if (!contadorPorSKU[sku]) {
        contadorPorSKU[sku] = 1; // Comenzar en 001 para cada SKU
      } 

      // Dividir la cantidad en múltiples registros según el mínimo requerido
      let cantidadRestante = cantidad;
      while (cantidadRestante > 0) {
          const cantidadActual = Math.min(minQuantity, cantidadRestante);
          const nuevoItem = {
              ...item,
              amount: cantidadActual,
              product: {
                ...producto,
                code: `${sku}_${String(contadorPorSKU[sku]).padStart(3, '0')}`, // Concatenar 
                amount: cantidadActual // Actualizar product.amount
              }
          };
          nuevoCarrito.push(nuevoItem);
          cantidadRestante -= cantidadActual;
          contadorPorSKU[sku]++;
      }
  });

  console.log('contadorPorSKU', contadorPorSKU);
  return nuevoCarrito;
}

export const getPriceWithDiscount = (product, unitsp, priceDiscount) => {
  const priceWithDiscount = getPriceWithDiscountList(product, unitsp, priceDiscount, 0);
  return priceWithDiscount.PriceWithDiscount;
};

export const getGanancia = (product, units, priceDiscount) => {
  return (((product.sugPrice * 100) / (priceDiscount).toFixed(1)) - 100).toFixed(1)
}